import React, { useRef, useState }  from 'react';
import { Modal, Button, Form }      from 'react-bootstrap';
import { useDispatch }              from 'react-redux';
import moment                       from 'moment';
import Swal                         from 'sweetalert2';

import { agendateAudiencesAction }  from '../../../../actions/audiencesActions';
import { ICON_CANCEL }              from '../../../extras/icons';
import { ErrorMessage }             from '../../../extras/toastMessages';
import ButtonSpinner                from '../../../layout/ButtonSpinner';
import clienteAxios                 from '../../../../config/axios';





const OptionsList = props => {


    // ------------------------------------------------------------------------------------------------------
    // DECLARACIONES ----------------------------------------------------------------------------------------
    // ------------------------------------------------------------------------------------------------------

    // Ref
    const refOperator = useRef();
    
    // Tomo los props
    const { show, handleClose, audience, options, judges } = props;
    
    // Inicializo el dispatch
    const dispatch = useDispatch();
    
    // Inicializo el state local
    const [errorOperator, setErrorOperator] = useState(false);
    const [loading, setLoading] = useState(false);
    const [observacion, setObservacion] = useState('');
    const [operators, setOperators] = useState([]);
    const [selectedEnviarEnlace, setSelectedEnviarEnlace] = useState('1');
    const [selectedOperator, setSelectedOperator] = useState('');

    

    // ------------------------------------------------------------------------------------------------------
    // FUNCIONES --------------------------------------------------------------------------------------------
    // ------------------------------------------------------------------------------------------------------
    
    // Manejo cuando se muestra
    const handleOnShow = e => {
        //Cargo los parámetros
        loadParameters();
        //Pongo el foco en el primer campo
        refOperator.current.focus();
    }
    
    // Manejo el guardado
    const handleSave = async selected => {
        //Pido confirmación
        Swal.fire({
            title: 'Agendar Audiencia',
            text: 'Se agendará la audiencia para: ' + moment(selected.inicio).format('DD/MM/YYYY HH:mm'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#1cc88a',
            confirmButtonText: 'Si, Agendar'
        }).then((result) => {
            if(result.value){
                //Ejecuto validación
                handleAgendate(selected);
            }
        })
    }
    
    // Función que maneja los parámetros
    const loadParameters = async () => {
        try
        {   //Cargo la espera
            setLoading(true);
            //Operadores
            const responseOperators = await clienteAxios.get(`/usuario?search=perfil.id:2,nivel.id:3,activo:1&sort=apellido:asc,nombre:asc`);
            //Seteo los datos
            setOperators(responseOperators.data.content);
            //Oculto la espera
            setLoading(false);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response)
            {   data = response.data;
            }
            //Oculto la espera
            setLoading(false);
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }

    // Manejo los cambios    
    const handleChangeEnviarEnlace = e => {
        //Seteo
        setSelectedEnviarEnlace(parseInt(e.target.value));
    }
    const handleChangeObservacion = e => {
        //Seteo
        setObservacion(e.target.value);
    }
    const handleChangeOperator = e => {
        //Seteo
        setSelectedOperator(e.target.value);
    }

    // Manejo los cambios
    const handleAgendate = selected => {
        //Me fijo si está seleccionado el operador
        if(selectedOperator && selectedOperator > 0)
        {   //Agrego el operador a los datos
            const data = {
                ...selected,
                operadorId: selectedOperator,
                enviarEnlace: selectedEnviarEnlace,
                observacion_agendamiento: observacion
            }
            //Llamo al dispatch
            dispatch( agendateAudiencesAction(audience, data, handleClose) );
        }
        else
        {   //Seteo el error
            setErrorOperator(true);
            //Muestro mensaje de error
            ErrorMessage('Debe seleccionar el Operador');
        }
    }
    
    

    // ------------------------------------------------------------------------------------------------------
    // RENDERIZO --------------------------------------------------------------------------------------------
    // ------------------------------------------------------------------------------------------------------

    return (
        <Modal
            show = { show } 
            onHide = { handleClose } 
            aria-labelledby = "contained-modal-title-vcenter" 
            centered
            size = "xl"
            onShow = { handleOnShow }
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    <strong>Opciones de Agendamiento</strong> <small>(Audiencia #{ audience.id })</small>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-12">
                        <div className="alert alert-info">
                            A continuación seleccione alguno de los espacios disponibles para agendar la audiencia.
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="alert alert-warning">
                            Juez/Jueces seleccionados:
                            <br/>
                            <strong>
                                {   judges.map((judge, index) => (
                                        `${ judge.apellido }, ${judge.nombre}${index > 0 ? ', ':''}`
                                    ))
                                }
                            </strong>
                        </div>
                    </div>
                    <Form.Group className="col-md-6">
                        <label htmlFor="operador">Operador</label>
                        <Form.Control
                            as = "select"
                            id = "operador"
                            className = "form-control"  
                            name = "operador" 
                            value = { selectedOperator }
                            onChange = { handleChangeOperator }
                            isInvalid = { errorOperator }
                            disabled = { loading }
                            ref = { refOperator }
                        >
                            <option value="">Seleccion el Operador...</option>
                            {   operators.map(operator => (
                                    <option value={operator.id} key={`olo${operator.id}`}>
                                        { operator.apellido + ', ' + operator.nombre }
                                    </option>
                                ))
                            }
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">
                            Debe seleccionar el operador para agendar.
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="col-md-6">
                        <label htmlFor="enviarEnlace">¿Enviar enlace de acceso a la audiencia remota?</label>
                        <Form.Control
                            as = "select"
                            id = "enviarEnlace"
                            className = "form-control"  
                            name = "enviarEnlace" 
                            value = { selectedEnviarEnlace }
                            onChange = { handleChangeEnviarEnlace }
                            disabled = { loading }
                        >
                            <option value="1">SI</option>
                            <option value="0">NO</option>
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">
                            Debe seleccionar si se enviará el enlace
                        </Form.Control.Feedback>
                    </Form.Group>                    
                    <Form.Group className="col-12">
                        <label htmlFor="observacion">Observaciones</label>
                        <Form.Control
                            id = "observacion"
                            className = "form-control" 
                            name = "observacion" 
                            as = "textarea" 
                            rows = { 2 }
                            placeholder = "Observaciones del Agendamiento"
                            value = { observacion }
                            onChange = { handleChangeObservacion }
                            disabled = { loading }
                        />
                    </Form.Group>
                    <table className="table">
                        <tbody>
                            {   options.map((option, index) => (
                                    option && option.length > 0 
                                        ? 
                                            <tr>
                                                {   option.slice(0, 3).map((op, index) => (
                                                        <td className="aling-middle text-center" key={`olo${index}`}>
                                                            <Button variant="success" onClick={() => handleSave(op)}>
                                                                <small>
                                                                    <strong>{ op.sala.descripcion }</strong>
                                                                    <br/>
                                                                    Inicio: <strong>{ moment(op.inicio).format('DD/MM/YYYY HH:mm') }</strong>
                                                                    <br/>
                                                                    Fin: <strong>{ moment(op.fin).format('DD/MM/YYYY HH:mm') }</strong>
                                                                </small>
                                                            </Button>
                                                        </td>
                                                    ))
                                                }
                                            </tr>
                                        :   
                                            null
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            </Modal.Body>
            <Modal.Footer>
                {   loading 
                        ? 
                            <ButtonSpinner />
                        : 
                            null
                }
                <Button variant="secondary" onClick={handleClose} disabled={ loading }>
                    <ICON_CANCEL /> Cancelar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default OptionsList;
